import HubSpotForm from './Form';

const HubSpot = (data) => {
  const type = data.type;
  
  return <HubSpotForm {...data} />;
};

export default HubSpot;